'use strict';

// Reserved keywords not allowed to use in the parser

module.exports = {
  end: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/expression/keywords.js
// module id = 630
// module chunks = 0